export default {
  //课中活动讨论
  signInfo: {
    detail:''
  },
  signList: '',
}
